import classes from "./LandingPageProducts.module.css";
import ProductsContainer from "../../Components/ProductsContainer/ProductsContainer";
import nv from "../../Assets/Images/nv.svg";
import globalVolunteerLogo from "../../Assets/Images/gv2.svg";
import globalTalentLogo from "../../Assets/Images/globalTalent.svg";
import globalTeacherLogo from "../../Assets/Images/globalTeacher.svg";
import globalVolunteerImg from "../../Assets/Images/Global Volunteer 1.jpeg";
import globalTalentImg from "../../Assets/Images/Global Talent 1.jpeg";
import globalTeacherImg from "../../Assets/Images/Global Teacher 1.jpeg";

const LandingPageProducts = () => {
  // OGX (Outgoing Exchange) programs
  const programs = [
    {
      // anchor target for the "I'm a Student" card in the About section
      anchorId: "student",
      logo: globalVolunteerLogo,
      image: globalVolunteerImg,
      title: "Global Volunteer",
      description:
        "Join social impact projects abroad that expand your worldview and build problem-solving skills.",
      url: "https://aiesec.org/global-volunteer",
    },
    {
      // anchor target for the "I'm a Graduate" card in the About section
      anchorId: "graduate",
      logo: globalTalentLogo,
      image: globalTalentImg,
      title: "Global Talent",
      description:
        "Access verified international internships across tech and marketing through AIESEC in Nigeria.",
      url: "https://aiesec.org/global-talent",
    },
    {
      anchorId: undefined,
      logo: globalTeacherLogo,
      image: globalTeacherImg,
      title: "Global Teacher",
      description:
        "Get paid to teach abroad and share your knowledge with the world.",
      url: "https://aiesec.org/global-teacher",
    },
  ];

  // National Volunteer (in-country) — rendered as its own block below the
  // OGX cards via the shared ProductsContainer component.
  const AiNProducts = [
    {
      bgColor: "#155D27",
      productLogo: nv,
      url: "https://aiesec.ng/nv",
      section: "country",
      header: "Volunteer within the country",
      introParagraph:
        "Develop your leadership through a volunteering project within Nigeria, contributing to one of the Sustainable Development Goals",
      productDetails: [
        {
          name: "Organizations",
          content: "A school or institution",
        },
        {
          name: "Duration",
          content: "For 2 weeks",
        },
      ],
      popularOppurtunities: null,
    },
  ];

  return (
    <>
      <section className={classes.container}>
        <div className={classes.header}>
          <p className={classes.eyebrow}>Gain a competitive edge</p>
          <h2>Work &amp; Volunteer Abroad</h2>
          <p className={classes.subtitle}>
            AIESEC in Nigeria connects students and graduates to international
            internships and cross-cultural volunteering opportunities.
          </p>
        </div>

        <div className={classes.cards}>
          {programs.map((program, i) => {
            return (
              <a
                className={classes.card}
                key={i}
                id={program.anchorId}
                href={program.url}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className={classes.cardBg}
                  src={program.image}
                  alt={program.title}
                  loading="lazy"
                />
                <span className={classes.badge}>
                  <img
                    src={program.logo}
                    alt={`${program.title} logo`}
                    loading="lazy"
                  />
                </span>
                <div className={classes.cardBody}>
                  <h4>{program.title}</h4>
                  <p>{program.description}</p>
                </div>
              </a>
            );
          })}
        </div>

        <div className={classes.explore}>
          <a
            href="https://aiesec.ng/ogx"
            target="_blank"
            rel="noreferrer"
          >
            Explore our programs{"   "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                opacity="0.7"
                d="M1.5 10.5L11 1M11 1H4.18868M11 1V7.63208"
                stroke="#037EF3"
                strokeWidth="1.43396"
              />
            </svg>
          </a>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="140"
            height="9"
            viewBox="0 0 140 9"
            fill="none"
          >
            <path
              d="M1 8C32.9147 8 64.6091 2.62996 96.6541 2.42885C109.944 2.34544 123.112 2.27783 136.382 2.42885C139.977 2.46976 139.818 1.86774 136.221 1.80981C129.836 1.707 123.967 0.769562 117.445 1.05324C105.402 1.57703 93.3188 1.20215 81.2624 1.67226C56.6761 2.63093 32.0651 2.27219 7.52737 3.04786"
              stroke="#037EF3"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </section>

      {AiNProducts.map((data, i) => (
        <ProductsContainer
          key={i}
          logo={data?.productLogo}
          url={data.url}
          section={data.section}
          backgroundColor={data.bgColor}
          header={data.header}
          introParagraph={data.introParagraph}
          productDetails={data.productDetails}
          popularOppurtunities={data.popularOppurtunities}
        />
      ))}
    </>
  );
};

export default LandingPageProducts;
